import { Image, Text, View } from '@react-pdf/renderer';
import { styles } from '../style/pdfStyles';
import {
  TRAVELIN_LOGO_DATA_URI,
  VISIT_BERGAMO_LOGO_DATA_URI,
} from '../assets/logos';

interface PdfHeaderProps {
  structureName: string;
}

export const PdfHeader = ({ structureName }: PdfHeaderProps) => (
  <View style={styles.header} fixed>
    <View style={styles.headerRow}>
      <Image src={TRAVELIN_LOGO_DATA_URI} style={styles.logoSmall} />
      <Image src={VISIT_BERGAMO_LOGO_DATA_URI} style={styles.logoSmall} />
    </View>
    <Text style={styles.headerSubtitle}>
      {structureName} - Passaporto di Accessibilita
    </Text>
  </View>
);
